import React from "react";
import ReactDOM, { hydrate, render } from "react-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import "bootstrap/dist/css/bootstrap.min.css";

// import "./index.css";
import * as serviceWorker from "./serviceWorker";

import App from "./App";
import Firebase, { FirebaseContext } from "./components/Firebase";

const rootElement = document.getElementById("root");
if (rootElement) {
  if (rootElement.hasChildNodes()) {
    hydrate(
      <Provider store={store}>
        <FirebaseContext.Provider value={new Firebase()}>
          <App />
        </FirebaseContext.Provider>
      </Provider>,
      rootElement,
    );
  } else {
    render(
      <Provider store={store}>
        <FirebaseContext.Provider value={new Firebase()}>
          <App />
        </FirebaseContext.Provider>
      </Provider>,
      rootElement,
    );
  }
}

// ReactDOM.render(
//   <Provider store={store}>
//     <FirebaseContext.Provider value={new Firebase()}>
//       <App />
//     </FirebaseContext.Provider>
//   </Provider>,
//   document.getElementById("root"),
// );

serviceWorker.unregister();
